import { ReactComponent as ErrorIcon } from "../assets/icons/voice/device-error.svg";
import { ReactComponent as InfoIcon } from "../assets/icons/voice/device-info.svg";
import { ReactComponent as OfflineIcon } from "../assets/icons/voice/device-offline.svg";
import { ReactComponent as ReadyIcon } from "../assets/icons/voice/device-ready.svg";
import { Spinner as SpinnerIcon } from "../components/Spinner";

/* eslint-disable */
import SwitchIcon from "!!url-loader!../assets/icons/voice/switch.svg";
import LightIcon from "!!url-loader!../assets/icons/voice/light.svg";
import DimmerIcon from "!!url-loader!../assets/icons/voice/dimmer.svg";
import RGBLightIcon from "!!url-loader!../assets/icons/voice/rgbLight.svg";
import TemperatureSensorIcon from "!!url-loader!../assets/icons/voice/temperatureSensor.svg";
import ThermostatIcon from "!!url-loader!../assets/icons/voice/thermostat.svg";
import BlindIcon from "!!url-loader!../assets/icons/voice/blind.svg";
import SceneTriggerIcon from "!!url-loader!../assets/icons/voice/sceneTrigger.svg";
/* eslint-enable */

export const deviceStatus = {
  unselected: <InfoIcon />,
  checking: <SpinnerIcon />,
  offline: <OfflineIcon />,
  invalid_device: <ErrorIcon />,
  invalid_firmware: <ErrorIcon />,
  empty: <InfoIcon />,
  ok: <ReadyIcon />,
  reprogrammed: <ErrorIcon />,
  generic_error: <ErrorIcon />,
};

export const controlTypes = {
  0: SwitchIcon,
  1: LightIcon,
  2: DimmerIcon,
  3: RGBLightIcon,
  4: TemperatureSensorIcon,
  5: ThermostatIcon,
  6: BlindIcon,
  7: SceneTriggerIcon,
};
